























helpers = require('../../helpers.coffee')

view_model = {
  components:
    resetContactModal: require('./modals/reset_contact_modal')
    taskModalForm: require('../manual_tasks/modal_form')
    listComposers: require('./compose/list')
    taskBar: require('../contacts/task_bar')
    dialer: require('../contacts/dialer')
    tagPickerModal: require('../tags/picker_modal')
    commentGlobalModal: require('./modals/comment')

  data: ->
    contact: null

  methods:
    confirmRemoveComment: ->
      EventsBus.$emit 'Comment::Destroy'

    openTagsModal: (data) ->
      @contact = data
      jQuery('#'+@tag_picker_id).modal('show')
      setTimeout(@$refs.tag_picker_modal.reloadTags,10)

    addTagsToContact: (tags) ->
      return unless tags.length
      contact_tags_attributes = for tag in tags
        { tag_id: tag.id }
      @contact_resource.update @addTagsSuccess, @unknownError, {id: @contact.id, contact_tags_attributes}

    addTagsSuccess: (data) ->
      @contact = data.contact
      EventsBus.$emit 'update-contact', @contact
      alertify.success('Tags adicionada ao contato com sucesso')

  created: ->
    @tag_picker_id = 'tag-picker'
    EventsBus.$on 'open-tag-picker-modal', @openTagsModal
    @contact_resource = new ContactsResource Session.current_company.id

  beforeDestroy:->
    EventsBus.$off 'open-tag-picker-modal', @openTagsModal
}
exports.default = helpers.vue_include(view_model,helpers.contacts.list_wrapper)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/global_boxes.vue